import * as Sentry from "@sentry/vue"
import { useUserDataStore } from "~/stores";

export default defineNuxtPlugin({
  name: "clerk-sync",
  dependsOn: ["clerk"],
  setup() {
    const userDataStore = useUserDataStore()
    const tokenCookie = useCookie("token")
    const config = useRuntimeConfig()

    const syncClerkSession = async (clerk) => {
      if (!clerk?.loaded) {
        return
      }

      if (!clerk.isSignedIn || !clerk.user) {
        tokenCookie.value = null
        userDataStore.setUser(null)
        userDataStore.setToken(null)
        userDataStore.setProfileComplete(null)
        Sentry.setUser(null)
        return
      }

      const token = await clerk.session?.getToken()
      tokenCookie.value = token || null
      userDataStore.setToken(token || null)
      userDataStore.setUser({
        id: clerk.user.id,
        email: clerk.user.primaryEmailAddress?.emailAddress || null,
        firstName: clerk.user.firstName || null,
        lastName: clerk.user.lastName || null,
        image: clerk.user.imageUrl || null,
        phone: clerk.user.primaryPhoneNumber?.phoneNumber || null,
        created_at: clerk.user.createdAt || null,
      })
      Sentry.setUser({
        id: clerk.user.id,
        email: clerk.user.primaryEmailAddress?.emailAddress || null,
        username: [clerk.user.firstName, clerk.user.lastName].filter(Boolean).join(' ') || null,
      })

      if (token) {
        try {
          const dbProfile = await $fetch(`${config.public.NUXT_API_BACK_URL}/user`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          const complete = !!(dbProfile?.cpf && dbProfile?.data_nasc && dbProfile?.endereco?.rua)
          userDataStore.setProfileComplete(complete)
          if (!complete && window.location.pathname !== '/auth/completar-cadastro') {
            navigateTo('/auth/completar-cadastro')
          }
        } catch {
          // fail open: don't redirect if API is unreachable
        }
      }
    }

    const bindWhenLoaded = () => {
      const clerk = window.Clerk

      if (!clerk) {
        window.setTimeout(bindWhenLoaded, 50)
        return
      }

      if (!clerk.loaded) {
        window.setTimeout(bindWhenLoaded, 50)
        return
      }

      syncClerkSession(clerk)
      clerk.addListener(() => syncClerkSession(clerk))
    }

    bindWhenLoaded()
  },
})
